module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_FMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Acknowledgments and Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_FMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Preface: Detroit’s Most Congenial Host")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("1.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Old Hopes, New Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("2.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stage Lights and Nightlife")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("3.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mayor of the Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("4.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Twenty-Dollar Man")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("5.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down on Hastings Street")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("6.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idlewild")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("7.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Every Day Is a New Story")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("8.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let It Roll!")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("9.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucky Old Fella")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_BMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_BMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b41fffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0